import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_41hrqq6ws3: FaireBrandEntity = {
  token: "b_41hrqq6ws3",
  type: "brand",
  name: "Three Bird Nest",
  avatarUrl:
    "https://cdn.faire.com/fastly/503a4882b31b6be6a8834d87988c2ae70ebc68e283390e75756e0b3b7a1b057d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a7e912bc98e8df48163885c3fce3a4d4a077eb9d3d44f69f23fbf20d71059cd1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/503a4882b31b6be6a8834d87988c2ae70ebc68e283390e75756e0b3b7a1b057d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a7e912bc98e8df48163885c3fce3a4d4a077eb9d3d44f69f23fbf20d71059cd1.jpeg",
  location: "Livermore, CA, USA",
  minimumOrderDollars: 346,
  rating: 4.7,
  reviewCount: 863,
  isInsider: true,
  description:
    "Since 2011, Three Bird Nest has inspired customers around the world through the expressive, vibrant style of boho fashion. Backed by exceptional customer support-we take a personal approach to wardrobing, curating the best in boho apparel, jewelry, and accessories. We’re here for the wanderers, the seekers, the free-thinkers. For those who dare to dream differently, dress boldly, and live authentically. \n\nAt Three Bird Nest, our mission is simple: to ignite creativity and self-expression in every customer through outfit-making pieces with value and accessibility in mind.  We can’t wait to see the many ways that you express your authentic self.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:45.993Z",
    importedBy: "entity-db-cli",
  },
};
